import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { get } from "./client";
import { chaves } from "./eventos";
import { hidratarRegistry, type Bootstrap } from "./registry";

/**
 * Carrega, numa única requisição, tudo que o registry síncrono precisa.
 *
 * Roda uma vez no boot e é invalidado por evento no WebSocket — quando um
 * profissional é criado ou a parametrização é versionada, por exemplo.
 */
export function useBootstrap() {
  const query = useQuery({
    queryKey: chaves.bootstrap,
    queryFn: () => get<Bootstrap>("/bootstrap"),
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (query.data) hidratarRegistry(query.data);
  }, [query.data]);

  return query;
}
